import React from "react"
import PCMEditCareView from "../components/PCMAdmin/PCMEditCare/PCMEditCare"

const PCMEditCare = () => <PCMEditCareView />

export default PCMEditCare
